import { LineRecord } from "@/components/FlowSheetEditor/services/modal"
import classNames from "classnames"
import "./unit.less";
import { StreamUnit } from "./components/StreamUnit/StreamUnit"
import { UnitTag } from "./UnitTag"

interface LineUnitPanelProps {
  unit: LineRecord
}

export const LineUnitPanel = (props: LineUnitPanelProps) => {
  const {unit} = props

  return <div style={{width: '100%', height: '100%'}}>
    <div className="unit-container">
      <div className={classNames('unit-header', 'flex-space-btw')}>
        <div>Stream</div>
        <UnitTag unit={unit} />
      </div>
      <div>
        <StreamUnit unitId={unit.streamId || unit.id}/>
      </div>
    </div>
  </div>
}